module.exports = __webpack_public_path__ + "static/media/search 2.56ba039d.svg";